import { RequestPost } from '../apiClient/api/RequestService';
import { refreshToken } from './RefreshToken';

function validateSetting() {
	return {type: "VALIDATE_SETTING"}
}

function validateSettingSuccess(content) {
	return {type: "VALIDATE_SETTING_SUCCESS", data: content}
}

function validateSettingFail() {
	return {type: "VALIDATE_SETTING_FAIL",message: "Có lỗi xảy ra"}
}


// function refreshToken(objData){
//     return async dispatch => {
//         const res = await RequestPost(`/v1/authentication/refresh-token`, objData)

//         if (res?.return_code === 1) {
//             dispatch(updateToken(res.data))
//         } 
//         else if (res?.return_code === 3022) {
//             dispatch(logout(objData.access_token, objData.refresh_token))
//         }
//     }
// }

export function setting(content, token) {
	return async dispatch => {
		dispatch(validateSetting());
		const params = {
			"app_id":content.appId,
			"branch_id":content.branchId,
			"store_id":content.storeId,
			"cashier_id":content.cashierId
		}
		const res = await RequestPost(`/v1/account/validate`, params, { token: token.access_token })
		if (res?.return_code === 1) {
			dispatch(validateSettingSuccess(content))
        } else if (res?.sub_return_code === 3021) {
			dispatch(refreshToken(token))
		}
		else {
			dispatch(validateSettingFail())
        }
	}
}
